import { Button, Heading, Text } from '@react-spectrum/s2';
import Delete from '@react-spectrum/s2/icons/Delete';
import Edit from '@react-spectrum/s2/icons/Edit';
import type { ReactNode } from 'react';

import { CARD, cardTitleStyles } from './styles';

type EditableCardProps = {
	title: string;
	isEditing: boolean;
	onEdit: () => void;
	onSave: () => void;
	onCancel: () => void;
	onRemove?: () => void;
	isSaveDisabled?: boolean;
	children: ReactNode;
	className?: string;
};

export const EditableCard = ({
	title,
	isEditing,
	onEdit,
	onSave,
	onCancel,
	onRemove,
	isSaveDisabled,
	children,
	className,
}: EditableCardProps) => {
	return (
		<div
			data-card-title={title}
			className={`${CARD} group flex flex-col gap-3 ${className ?? ''}`}
		>
			<div className="flex items-start justify-between">
				<Heading level={3} styles={cardTitleStyles}>
					{title}
				</Heading>
				{isEditing ? (
					<div className="flex gap-2">
						<Button variant="secondary" size="S" onPress={onCancel}>
							Cancel
						</Button>
						<Button
							variant="primary"
							size="S"
							onPress={onSave}
							isDisabled={isSaveDisabled}
						>
							Save
						</Button>
					</div>
				) : (
					<div
						className="flex gap-2 opacity-0 transition-opacity
							group-hover:opacity-100"
					>
						{onRemove && (
							<Button variant="secondary" size="S" onPress={onRemove}>
								<Delete />
								<Text>Remove</Text>
							</Button>
						)}
						<Button variant="primary" size="S" onPress={onEdit}>
							<Edit />
							<Text>Edit</Text>
						</Button>
					</div>
				)}
			</div>
			{children}
		</div>
	);
};
